import loadable from 'components/dynamic-import';

const ConnectedAuthProviders = loadable(() => import('./ConnectedAuthProviders'), true);

export default ConnectedAuthProviders;
